<template>
  <ModalForm
    :modal="modal"
    :successModalData="successModalData"
    :show="showModal"
    @handleModal="handleFormInModal"
  />
  <div class="product-category-details">
    <div class="desc-container">
      <h1 class="h2" v-if="productCategoryDetails.info.title">{{ productCategoryDetails.info.title }}</h1>
      <div v-html="productCategoryDetails.info.description"/>
      <div
        v-if="productCategoryDetails.info.manufactured !== null ||
              productCategoryDetails.info.secondManufactured !== null"
        class="d-flex flex-column align-items-start see-more-container border">
        <p class="see-more__title">See More From Manufacturers:</p>
        <div>
          <Link
            v-if="productCategoryDetails.info.manufactured"
            :href="productCategoryDetails.info.manufactured.link.link"
            class="see-more__manufacturer">
            <img :src="productCategoryDetails.info.manufactured.logo.link"
                 :alt="productCategoryDetails.info.manufactured.logo.alt">
          </Link>
          <Link
            v-if="productCategoryDetails.info.secondManufactured"
            :href="productCategoryDetails.info.secondManufactured.link.link"
            class="see-more__manufacturer">
            <img :src="productCategoryDetails.info.secondManufactured.logo.link"
                 :alt="productCategoryDetails.info.secondManufactured.logo.alt">
          </Link>
        </div>
      </div>
      <div class="d-flex flex-column flex-lg-row flex-lg-wrap btns-section">
        <template v-for="action in productCategoryDetails.info.buttons">
          <RedCircle class="btns-section-item" hyperlink :href="action.link" :text="action.title" v-if="action.link">
            <span v-html="action.icon"/>
          </RedCircle>
          <RedCircle class="btns-section-item" :text="action.title" v-else @click="handleFormInModal">
            <span v-html="action.icon"/>
          </RedCircle>
        </template>
      </div>
      <div class="d-flex back-btn mt-4" v-if="productCategoryDetails.backButton?.url">
        <Link :href="productCategoryDetails.backButton.url"
              class="btn-nulled px-0 action-back d-flex align-items-center">
          <BackToTopIcon class="me-2"/>
          <span>{{ productCategoryDetails.backButton.text }}</span>
        </Link>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref} from 'vue'
import RedCircle from "@/components/common/RedCircle";
import Link from "@/components/common/Link";
import BackToTopIcon from "@/assets/icons/back-to-top-icon";
import ModalForm from "@/components/common/modals/ModalForm.vue";

const {productCategoryDetails, modal} = defineProps({
  productCategoryDetails: {
    info: {
      title: String
    },
    manufactured: {
      logo: {
        link: String,
        alt: String
      }
    },
    secondManufactured: {
      logo: {
        link: String,
        alt: String
      }
    },
    link: {
      text: String,
      link: String
    },
    buttons: [
      {
        icon: HTMLElement,
        link: String,
        title: String,
      }
    ],
    backButton: {
      text: String,
      url: String,
    }
  },
  modal: Object,
  successModalData: Object
})

modal.title = modal.title + ' ' + productCategoryDetails.info.title

let showModal = ref(false)

const handleFormInModal = () => showModal.value = !showModal.value
</script>
